import * as React from 'react'
import {inject, observer} from 'mobx-react'
import {Redirect, withRouter} from 'react-router'
import {StoreProps} from 'src/stores'
import Loading from 'src/components/atoms/Loading'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import Question from 'src/components/atoms/wizard/Question'

const Cookies = require('js-cookie')
const queryString = require('query-string')

interface State {
  valid: boolean
}

@inject('wizardStore')
@observer
export class WizardLoading extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    this.state = { valid: false }
    this.extractOfferParameters()
  }

  extractOfferParameters() {
    const parameters = queryString.parse(location.search)
    const { wizardStore } = this.props
    wizardStore.basics.gclId = Cookies.get('_bn_gclid')
    if (parameters.previousPage)
      wizardStore.basics.previousPage = parameters.previousPage
    if (
      parameters &&
      parameters.planningReason &&
      parameters.funeralType &&
      parameters.zipCode
    ) {
      wizardStore.basics.planningReason = parameters.planningReason
      wizardStore.basics.funeralType = parameters.funeralType
      wizardStore.location.zipCode = parameters.zipCode
    }
  }

  componentDidMount() {
    const timeout = Math.floor(Math.random() * Math.floor(2000)) + 2500
    setTimeout(() => {
      this.setState({ valid: true })
    }, timeout)
  }

  render() {
    const { wizardStore } = this.props
    const { valid } = this.state

    let preamble = ''
    if (wizardStore.basics.planningReason === 'ACUTE_BEREAVEMENT')
      preamble = 'eingetreten'
    if (wizardStore.basics.planningReason === 'IMPENDING_BEREAVEMENT')
      preamble = 'bevorstehend'
    if (wizardStore.basics.planningReason === 'PROVISION') preamble = 'vorsorge'

    if (!wizardStore.basics.planningReason)
      return <Redirect to='/planung/anliegen/' />
    // Not using wizardStore.nextWizardStep here is necessary
    //  as there is no data change during that step
    if (valid)
      return <Redirect to={`/planung/${preamble}/kontakt/${location.search}`} />

    return (
      <WizardContainer>
        <Box>
          <Question>Ihr persönliches Angebot wird erstellt</Question>
          <Loading />
        </Box>
      </WizardContainer>
    )
  }
}

export default withRouter(WizardLoading)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/WizardLoading.tsx